import RequestStatus from "../model/RequestStatus";
import { UserInput, UserInputResponse } from "../model/UserInput";

export const USER_INPUT_QUERY_START = 'USER_INPUT_QUERY_START';
export const USER_INPUT_QUERY_SUCCESS = 'USER_INPUT_QUERY_SUCCESS';
export const USER_INPUT_QUERY_FAILED = 'USER_INPUT_QUERY_FAILED';

export const USER_INPUT_UPDATE_START = 'USER_INPUT_UPDATE_START';
export const USER_INPUT_UPDATE_SUCCESS = 'USER_INPUT_UPDATE_SUCCESS';
export const USER_INPUT_UPDATE_FAILED = 'USER_INPUT_INPUT_FAILED';

export interface UserInputQueryStartAction {
    readonly type: string;
    readonly asin: string;
    readonly mSku: string;
    readonly countryCode: string;
    readonly requestStatus: RequestStatus;
}

export const setUserInputQueryStart = (asin: string, mSku: string, countryCode: string): UserInputQueryStartAction => ({
    type: USER_INPUT_QUERY_START,
    asin: asin,
    mSku: mSku,
    countryCode: countryCode,
    requestStatus: RequestStatus.LOADING,
});

export interface GetUserInputQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly UserInput: any;
}

export const getUserInputQuerySuccessAction = (response: UserInputResponse): GetUserInputQueryComplete => ({
    type: USER_INPUT_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    UserInput: response.userInput
});

export const getUserInputQueryFailedAction = (): GetUserInputQueryComplete => ({
    type: USER_INPUT_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    UserInput: null
});

export interface UserInputUpdateStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly UserInput: UserInput;
}

export interface GetUserInputUpdateComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly UserInput: any;
}

export const setUserInputUpdateStart = (userInput: UserInput) : UserInputUpdateStartAction => ({
    type: USER_INPUT_UPDATE_START,
    requestStatus: RequestStatus.LOADING,
    UserInput: userInput
});

export const setUserInputUpdateSuccessAction = (userInput: UserInput): GetUserInputUpdateComplete => ({
    type: USER_INPUT_UPDATE_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    UserInput: userInput
});

export const setUserInputUpdateFailedAction = (): GetUserInputUpdateComplete => ({
    type: USER_INPUT_UPDATE_FAILED,
    requestStatus: RequestStatus.ERROR,
    UserInput: null
});
